import { SEO } from "../components/SEO";
import { CTA } from "../components/sections/CTA";
import { FAQ } from "../components/sections/FAQ";
import { Hero } from "../components/sections/Hero";
import { Process } from "../components/sections/Process";
import { ServicesGrid } from "../components/sections/ServicesGrid";
import { WhyUs } from "../components/sections/WhyUs";
import { ZonesSection } from "../components/sections/ZonesSection";
import { faq } from "../data/faq";
import {
  breadcrumbJsonLd,
  faqJsonLd,
  localBusinessJsonLd,
  websiteJsonLd,
} from "../lib/structured-data";
import { site } from "../lib/site";

export function Home() {
  return (
    <>
      <SEO
        title="Agent d'entretien à Vichy - Nettoyage pro bureaux, Airbnb, copropriétés"
        description="Société de nettoyage à Vichy (03) : bureaux, copropriétés, commerces, Airbnb / locations courtes durées, vitres et fin de chantier. Interlocuteur unique, produits éco, devis gratuit sous 48 h dans l'Allier."
        path="/"
        jsonLd={[
          localBusinessJsonLd(),
          websiteJsonLd(),
          faqJsonLd(faq),
          breadcrumbJsonLd([{ name: "Accueil", url: `${site.baseUrl}/` }]),
        ]}
      />
      <Hero />
      <ServicesGrid />
      <WhyUs />
      <Process />
      <ZonesSection />
      <FAQ />
      <CTA />
    </>
  );
}
